import React from 'react';
import Image from  'next/image'
import { Container} from 'react-bootstrap'
import NavBar from '../NavBar';
import { Background, BgNav, Content } from './styles';

const Banner = () => {

    const linksNavbar = [
        {
            id: '01',
            link:'https://fotop.io',
            target:'_blank',
            label:'Sou Fotógrafo'
        },
        {
            id: '02',
            link:'/business',
            target:'',
            label:'Business'
        },
        {
            id: '03',
            link:'https://ajuda.fotop.com.br/kb/pt-br/form/1812',
            target:'_blank',
            label:'Contato'
        },
        {
            id: '04',
            link:'/login',
            target:'',
            label:'Login'
        },

    ]

    const buttonBusness = {
        hasButton: true,
        link: "http://business.fotografoja.com/sou-fotografo/",
        label: "Sou fotógrafo"
    }

  return (
      <Background>
         <BgNav>
               <NavBar links={linksNavbar} />
         </BgNav>

          <Container>
                <Content>
                    <div >
                        <p>
                            FOTOP SERVIÇOS DIRETO
                        </p>

                        <h1>
                            Indicamos profissionais qualificados para a sua necessidade ou da sua empresa
                        </h1>

                    </div>

                    <a href="#information">
                        <Image src="/images/arrow-down.png" alt="seta para baixo" width={30} height={22} />
                    </a>

                </Content>
          </Container>
      </Background>
  )
}

export default Banner;
